import React, { Component } from 'react';
import {
  Box,
  Grid,
  Typography,
  Paper,
  Snackbar,
  Alert,
  Chip,
  Container,
  Card,
  CardActionArea,
  CardContent,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import SpeedIcon from '@mui/icons-material/Speed';
import ExtensionIcon from '@mui/icons-material/Extension';
import SchoolIcon from '@mui/icons-material/School';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { withTranslation } from 'react-i18next';

import '../login/LoginPageStyles.css';
import './WelcomePage.css';

const session = require('../../config/session');

let hoy = new Date();
let año = hoy.getFullYear();

const HELP_VIDEOS = [
  {
    id: 'g_Ah-c-seoc',
    title: 'Cómo realizar depósitos',
    description: 'Inicio de sesión, recepción de billetes, manejo de rechazos, depósitos por sobre e impresión de comprobantes.',
    audience: 'Usuarios y operadores',
    Icon: SchoolIcon,
    color: '#6A9E2C',
  },
  {
    id: 'ftKbYHzmA4o',
    title: 'Mantenimiento del lector de billetes',
    description: 'Apertura correcta del lector, revisión interna, verificación de atascos, ajuste de pestañas y reinstalación segura.',
    audience: 'Mantenimiento preventivo',
    Icon: SettingsApplicationsIcon,
    color: '#6A4FB2',
  },
];

const FEATURES = [
  {
    icon: <SpeedIcon sx={{ fontSize: 36 }} />,
    title: 'Alto rendimiento',
    text: 'Optimizados para operación continua en cualquier entorno.',
  },
  {
    icon: <ExtensionIcon sx={{ fontSize: 36 }} />,
    title: 'Diseño modular',
    text: 'Hardware y software flexibles para ampliar funciones sobre la base original.',
  },
  {
    icon: <VerifiedIcon sx={{ fontSize: 36 }} />,
    title: 'Mejor costo-resultado',
    text: 'Inversión optimizada para cubrir todas las necesidades de efectivo.',
  },
];

class WelcomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: '',
    };
  }

  handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ mostrarAlerta: false });
  };

  componentDidMount() {
    session.endSession();
  }

  render() {
    return (
      <Box className="welcome-root">
        {/* Header */}
        <Box className="welcome-header">
          <a href="https://www.selfia.net/" className="welcome-header-logo-link">
            <Box
              component="img"
              src="/entidades/logo_selfia_classic.png"
              alt="Selfia"
              className="welcome-header-logo"
            />
          </a>
          <Typography variant="h4" className="welcome-header-title">
            Sistema de información de depositarios
          </Typography>
        </Box>

        {/* Hero */}
        <Box className="welcome-hero">
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={7}>
                <Chip
                  label="Smart Boxes · Soluciones de efectivo"
                  className="welcome-hero-chip"
                  size="small"
                />
                <Typography variant="h3" className="welcome-hero-title">
                  Depositarios inteligentes para tu negocio
                </Typography>
                <Typography variant="body1" className="welcome-hero-text">
                  Nuestra familia de Smart Boxes asegura la mejor inversión costo-resultado para
                  cubrir las necesidades de manejo de efectivo en cualquier tipo de ambiente.
                  Desarrollados sobre una arquitectura de hardware y software flexible, permiten
                  ampliar funciones sobre la base de su configuración original. Su diseño modular
                  facilita la integración de dispositivos que se adaptan a la presentación
                  requerida, sumando funcionalidades para hacer crecer su operación.
                </Typography>
              </Grid>
              <Grid item xs={12} md={5}>
                <Box className="welcome-hero-image-wrap">
                  <Box
                    component="img"
                    src="/Pegasus0.png"
                    alt="Depositario inteligente"
                    className="welcome-hero-image"
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Features */}
            <Grid container spacing={3} className="welcome-features">
              {FEATURES.map((f) => (
                <Grid item xs={12} sm={6} md={4} key={f.title}>
                  <Paper elevation={0} className="welcome-feature-card">
                    <Box className="welcome-feature-icon">{f.icon}</Box>
                    <Typography variant="h6" className="welcome-feature-title">
                      {f.title}
                    </Typography>
                    <Typography variant="body2" className="welcome-feature-text">
                      {f.text}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* Videos de ayuda */}
        <Box className="welcome-videos">
          <Container maxWidth="lg">
            <Box className="welcome-section-head">
              <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, mb: 1.2 }}>
                <OndemandVideoIcon sx={{ color: '#6A9E2C' }} />
                <Chip label="Centro de aprendizaje" className="welcome-section-chip" size="small" />
              </Box>
              <Typography variant="h4" className="welcome-section-title">
                Videos de ayuda · Depositario Inteligente
              </Typography>
              <Typography variant="body1" className="welcome-section-subtitle">
                Toca una tarjeta para abrir el video en YouTube.
              </Typography>
            </Box>

            <Grid container spacing={3} justifyContent="center">
              {HELP_VIDEOS.map((v, idx) => {
                const VideoIcon = v.Icon;
                return (
                  <Grid item xs={12} sm={6} md={5} key={v.id}>
                    <Card className="welcome-video-card">
                      <CardActionArea
                        href={`https://youtu.be/${v.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Box
                          className="welcome-video-thumb-wrap"
                          style={{
                            background: `linear-gradient(135deg, ${v.color} 0%, ${v.color}cc 60%, #1f1f1f 100%)`,
                          }}
                        >
                          <Box className="welcome-video-thumb-pattern" />
                          <Box className="welcome-video-thumb-icon">
                            <VideoIcon style={{ fontSize: 72, color: '#ffffff', opacity: 0.85 }} />
                          </Box>
                          <Box className="welcome-video-overlay">
                            <PlayCircleOutlineIcon className="welcome-video-play" />
                          </Box>
                          <Box
                            className="welcome-video-number"
                            style={{ backgroundColor: '#ffffff', color: v.color }}
                          >
                            {idx + 1}
                          </Box>
                        </Box>
                        <CardContent className="welcome-video-content">
                          <Box className="welcome-video-meta" sx={{ justifyContent: 'flex-end !important' }}>
                            <Chip
                              label={v.audience}
                              size="small"
                              className="welcome-video-audience"
                              style={{ backgroundColor: `${v.color}1A`, color: v.color }}
                            />
                          </Box>
                          <Typography variant="h6" className="welcome-video-title">
                            {v.title}
                          </Typography>
                          <Typography variant="body2" className="welcome-video-desc">
                            {v.description}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Container>
        </Box>

        {/* Kioskos band - al final */}
        <Box className="welcome-kioskos-band">
          <Container maxWidth="xl">
            <Box
              component="img"
              src="/kioskos.png"
              alt="Familia de Smart Boxes"
              className="welcome-kioskos-img"
            />
          </Container>
        </Box>

        {/* Footer */}
        <Box className="welcome-footer">
          <Typography variant="caption">
            © {año} Selfia. All rights reserved.
          </Typography>
        </Box>

        <Snackbar
          open={this.state.mostrarAlerta}
          autoHideDuration={4000}
          onClose={this.handleCloseAlert}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={this.handleCloseAlert}
            severity={this.state.severidadAlerta || 'info'}
            sx={{ width: '100%' }}
          >
            {this.state.mensajeAlerta}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default withTranslation()(WelcomePage);
